import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { useRider } from '../../hooks/useRiders';
import RiderForm from './RiderForm';
import { v4 as uuidv4 } from 'uuid';

export default function RiderView(): ReactElement {
  const { riderId } = useParams<{ riderId: string }>();
  if (riderId === 'new') {
    return (
      <RiderForm
        isNew={true}
        rider={{ id: uuidv4(), time_ref_minutes: 60, distance_ref_km: 40, speed_ref_kmh: 40, power_ref: 250 }}
        isRiderPending={false}
        isRiderFetching={false}
      />
    );
  }
  const { data: rider, isPending: isRiderPending, isFetching: isRiderFetching } = useRider(riderId || '');

  return <RiderForm isNew={false} rider={rider} isRiderPending={isRiderPending} isRiderFetching={isRiderFetching} />;
}
